import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioFormaPagamento } from '../../sync/repositories/financeiro';
import { extrairMensagensErro } from '../../utils/errorUtils';

/**
 * Modal de cadastro rápido de Forma de Pagamento.
 * Cobre só nome + tipo (à vista/a prazo) — parcelamento, taxas e demais
 * regras ficam para a tela de Gestão de Formas de Pagamento.
 */
export default function ModalCadastroFormaPagamento({ isOpen, onClose, onSuccess }) {
  const [nome, setNome] = useState('');
  const [tipo, setTipo] = useState('avista');
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setNome('');
      setTipo('avista');
      setErros([]);
      setSalvando(false);
    }
  }, [isOpen]);

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!nome.trim()) { setErros(['O nome é obrigatório.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioFormaPagamento.criar({
        nome: nome.trim(),
        tipo,
        ativo: true,
      });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Forma de Pagamento">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Pix, Boleto, Cartão de Crédito..."
            autoFocus
            disabled={salvando}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Tipo *</label>
          <select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            disabled={salvando}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300 bg-white"
          >
            <option value="avista">À vista</option>
            <option value="aprazo">A prazo</option>
          </select>
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
